module.exports = __webpack_public_path__ + "img/img25.1e35b628.svg";